import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomInputTypeComponent } from './components/custom-input-type/custom-input-type.component';
import { RdsapBandComponent } from './components/rdsap-band/rdsap-band.component';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { SaveEditComponent } from './components/save-edit/save-edit.component';
import { FormsModule } from '@angular/forms';
import { PcdbDataTableViewComponent } from './components/pcdb-data-table-view/pcdb-data-table-view.component';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';


@NgModule({
  declarations: [
    CustomInputTypeComponent,
    RdsapBandComponent,
    ConfirmDialogComponent,
    SaveEditComponent,
    PcdbDataTableViewComponent,
    HeaderComponent,
    FooterComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
  ],
  exports: [
    CustomInputTypeComponent,
    RdsapBandComponent,
    ConfirmDialogComponent,
    SaveEditComponent,
    PcdbDataTableViewComponent,
    HeaderComponent,
    FooterComponent
  ]
})
export class SharedModule { }
